import store from '../store/Store'
import actionTypes from '../actionTypes/actionTypes'
import config from '../config/Config'

const URL = config.PRODUCTION ? config.HTTP + config.API_PRODUCTION_HOST + ':' + config.API_PRODUCTION_PORT + config.API_LOGIN : config.HTTP + config.LOCAL_HOST + ':' + config.API_LOCAL_PORT + config.API_LOGIN

// console.log(URL)

async function requestLogin(data) {
	const user = data.user ? data.user : {}

	const res = await fetch(URL, {
		method: "POST",
		mode: "cors",
		headers: {
		  'Accept': 'application/json',
		  'Content-Type': 'application/json',
		  'Access-Control-Allow-Origin': '*'
		},
		body: JSON.stringify({
			username: user.username || '',
			password: user.password || ''
		})
	})

	return await res.json()
}

async function requestLogout(data) {
	const action = {
		type: actionTypes.REQUEST_LOGOUT,
		data
	}

	store.dispatch(action)
}

const loginActions = {
	requestLogin,
	requestLogout
}

export default loginActions;